import React from 'react';
import styled from 'styled-components';

import { Card, ListGroup, Row, Col } from 'react-bootstrap';
import StyledColoredTag from '../../../app/components/styledComponents/StyledColoredTag';
import CircleIcon from '../../../app/components/svgIcons/CircleIcon';
import { orderStatuses } from '../assets/orderUtil';
import {
  capitalizeFirstLetter,
  underscoreToFriendlyName,
} from '../../../utils/helper';

const SendOrdersListView = ({ tableData }) => {
  const getVaraintColor = (tag) => {
    if (tag === orderStatuses.ORDER_REJECTED) {
      return 'danger';
    } else if (tag === orderStatuses.ORDER_ASSIGNED) {
      return 'success';
    } else {
      return 'blue';
    }
  };

  return (
    <Row>
      <Col md={3}>
        <ListGroup>
          <Card>
            {tableData?.content?.map((item, index) => (
              <ListItemContainer key={index}>
                <ProductImage>
                  <img
                    loading="lazy"
                    className="rounded-circle"
                    src={item?.orderDetails?.[0].imageUrl}
                    alt=""
                  />
                </ProductImage>
                <OrderInfoBox>
                  <ProductName>{item?.orderDetails?.[0].itemName}</ProductName>

                  <StyledColoredTag
                    className={` ${
                      item?.orderStatusId === orderStatuses.ORDER_REJECTED
                        ? 'cursor-pointer'
                        : ''
                    }`}
                    style={{ width: 'fit-content' }}
                    variant={getVaraintColor(item?.orderStatusId)}
                    $marginX={'0'}
                    // onClick={() => setRejectionReason(item?.statusMessage || '')}
                  >
                    <CircleIcon className="me-1" />
                    {capitalizeFirstLetter(
                      underscoreToFriendlyName(item?.orderStatus),
                    ) || ''}
                  </StyledColoredTag>
                </OrderInfoBox>
              </ListItemContainer>
            ))}
          </Card>
        </ListGroup>
      </Col>
      <Col md={9}>detail view</Col>
    </Row>
  );
};

const ListItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e0e0e0;
  margin-top: 20px;
`;

const ProductImage = styled.div`
  width: 42px;
  height: 42px;
  overflow: hidden;

  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-left: 10px;
  }

  &:before {
    position: absolute;
    content: '';
    height: 30px;
    border-radius: 0 10px 10px 0;
    background: ${({ theme }) => theme.primary};
    left: 0;
    width: 5px;
  }
`;

const OrderInfoBox = styled.div`
  padding: 10px;
  width: 100%;
`;

const ProductName = styled(Card.Title)`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
  width: max-content;
  max-width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.primaryDark};
`;

export default SendOrdersListView;
